import React, { useEffect, useState, useRef } from 'react'
import { Table, Button, Modal, Input, Select, DatePicker, Tag } from 'antd'
import {
  PlusOutlined,
  DeleteOutlined,
  EyeOutlined,
  EditOutlined,
  SlackOutlined,
  MinusOutlined,
} from '@ant-design/icons'
import axiosInstance from '../../Utils/axiosInstance'
import { toast } from 'react-toastify'
import dayjs from 'dayjs'

import {
  GetCustomerDataAPI,
  CreateDeliveryDataAPI,
  GetDeliveryDataAPI,
  GetProductDataByBarcodeAPI,
  UpdateDeliveryDataAPI,
} from '../../AllAPI/AdminAPI'

const Delivery = () => {
  const selectedYear = Number(sessionStorage.getItem('year'))

  /* ================= LIST ================= */
  const [delivery, setDelivery] = useState([])
  const [filteredDelivery, setFilteredDelivery] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchText, setSearchText] = useState('')

  const [productName, setProductName] = useState('')
  const [productSize, setProductSize] = useState('')
  const [rate, setRate] = useState('')

  const [submitLoading, setSubmitLoading] = useState(false)
  const [actionLoadingId, setActionLoadingId] = useState(null)
  const [addBtnLoading, setAddBtnLoading] = useState(false)

  /* ================= MASTER ================= */
  const [customers, setCustomers] = useState([])

  /* ================= MODALS ================= */
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [viewModal, setViewModal] = useState(false)
  const [selectedDelivery, setSelectedDelivery] = useState(null)

  /* ================= HEADER ================= */
  const [deliveryDate, setDeliveryDate] = useState(null)
  const [customerId, setCustomerId] = useState(null)

  /* ================= FLAGS ================= */
  const isFetchingRef = useRef(false)

  const resetFields = () => {
    setProductId('')
    setProductName('')
    setProductSize('')
    setRate('')
    setQty(1)
    setItems([])
  }

  const deliveryColumns = [
    { title: 'Delivery Id', dataIndex: 'delivery_id' },
    {
      title: 'Date',
      dataIndex: 'date',
      render: (d) => dayjs(d).format('DD-MM-YYYY'),
    },
    { title: 'Customer Name', dataIndex: 'customer_name' },
    {
      title: 'Delivered Qty',
      render: (_, record) => {
        const totalQty = (record.items || []).reduce(
          (sum, item) => sum + Number(item.quantity || 0),
          0,
        )
        return <div style={{ textAlign: 'right' }}>{totalQty}</div>
      },
    },
    {
      title: 'Total Amount (₹)',
      render: (_, record) => {
        const totalAmt = (record.items || []).reduce(
          (sum, item) =>
            sum + Number(item.quantity || 0) * Number(item.rate || 0),
          0,
        )

        return (
          <div style={{ textAlign: 'right', fontWeight: 600 }}>{totalAmt}</div>
        )
      },
    },

    {
      title: 'Status',
      dataIndex: 'status',
      render: (status) => {
        if (status === 1) {
          return <Tag color="green">Delivered</Tag>
        }
        if (status === 2) {
          return <Tag color="blue">Invoiced</Tag>
        }
        return <Tag color="default">-</Tag>
      },
    },
    // {
    //   title: 'Action',
    //   render: (_, record) => (
    //     <>
    //       <Button
    //         type="text"
    //         title="View"
    //         icon={<EyeOutlined />}
    //         // onClick={() => {
    //         //   setSelectedDelivery({
    //         //     items: record.items.map((i, idx) => ({
    //         //       key: idx,
    //         //       product_name: i.product_name,
    //         //       size: i.size,
    //         //       qty: i.quantity,
    //         //       rate: i.rate,
    //         //     })),
    //         //   })
    //         //   setViewModal(true)
    //         // }}

    //         onClick={() => {
    //           const totalQty = (record.items || []).reduce(
    //             (sum, i) => sum + Number(i.quantity || 0),
    //             0,
    //           )

    //           const totalAmt = (record.items || []).reduce(
    //             (sum, i) => sum + Number(i.quantity || 0) * Number(i.rate || 0),
    //             0,
    //           )

    //           setSelectedDelivery({
    //             delivery_id: record.delivery_id,
    //             date: record.date,
    //             customer_name: record.customer_name,
    //             items: record.items.map((i, idx) => ({
    //               key: idx,
    //               product_name: i.product_name,
    //               size: i.size,
    //               qty: i.quantity,
    //               rate: i.rate,
    //               amount: Number(i.quantity || 0) * Number(i.rate || 0),
    //             })),
    //             totalQty,
    //             totalAmt,
    //           })

    //           setViewModal(true)
    //         }}
    //       />

    //       <Button
    //         type="text"
    //         title="Edit"
    //         icon={<EditOutlined />}
    //         disabled={record.status === 2}
    //         onClick={() => handleEdit(record)}
    //       />
    //     </>
    //   ),
    // },
    {
      title: 'Action',
      render: (_, record) => (
        <>
          <Button
            type="text"
            icon={<EyeOutlined />}
            loading={actionLoadingId === `view-${record.delivery_id}`}
            onClick={() => {
              setActionLoadingId(`view-${record.delivery_id}`)

              const totalQty = (record.items || []).reduce(
                (sum, i) => sum + Number(i.quantity || 0),
                0,
              )

              const totalAmt = (record.items || []).reduce(
                (sum, i) => sum + Number(i.quantity || 0) * Number(i.rate || 0),
                0,
              )

              setSelectedDelivery({
                delivery_id: record.delivery_id,
                date: record.date,
                customer_name: record.customer_name,
                items: record.items.map((i, idx) => ({
                  key: idx,
                  prod_id: i.prod_id,
                  product_name: i.product_name,
                  size: i.size,
                  qty: i.quantity,
                  rate: i.rate,
                  amount: Number(i.quantity || 0) * Number(i.rate || 0),
                })),
                totalQty,
                totalAmt,
              })

              setViewModal(true)
              setActionLoadingId(null)
            }}
          />

          <Button
            type="text"
            icon={<EditOutlined />}
            disabled={record.status === 2}
            loading={actionLoadingId === `edit-${record.delivery_id}`}
            onClick={() => {
              setActionLoadingId(`edit-${record.delivery_id}`)
              handleEdit(record)
              setActionLoadingId(null)
            }}
          />
        </>
      ),
    },
  ]

  const tempColumns = [
    { title: 'Product ID', dataIndex: 'product_id' },
    {
      title: 'Product',
      render: (_, r) => `${r.product_name} (${r.size})`,
    },
    { title: 'Qty', dataIndex: 'qty' },
    { title: 'Rate (₹)', dataIndex: 'rate' },
    {
      title: 'Action',
      render: (_, record, index) => (
        <Button
          danger
          size="small"
          title="Delete"
          icon={record.qty > 1 ? <MinusOutlined /> : <DeleteOutlined />}
          onClick={() => removeItem(index)}
        />
      ),
    },
  ]
  /* ================= SCAN ================= */
  const [productId, setProductId] = useState('')
  const [qty, setQty] = useState(1)

  /* ================= EDIT ================= */
  const [isEdit, setIsEdit] = useState(false)
  const [editId, setEditId] = useState(null)

  /* ⭐ ORIGINAL QTY MAP (IMPORTANT FIX) */
  const [originalQtyMap, setOriginalQtyMap] = useState({})

  /* ================= ITEMS ================= */
  const [items, setItems] = useState([])

  const scanRef = useRef(null)

  useEffect(() => {
    fetchCustomers()
    fetchDelivery()
  }, [])

  /* ================= FETCH ================= */
  const fetchCustomers = async () => {
    const res = await axiosInstance.get(`${GetCustomerDataAPI}/${selectedYear}`)
    setCustomers(res.data || [])
  }

  const fetchDelivery = async () => {
    try {
      setLoading(true)
      const res = await axiosInstance.get(
        `${GetDeliveryDataAPI}/${selectedYear}`,
      )
      setDelivery(res.data || [])
      setFilteredDelivery(res.data || [])
    } catch {
      toast.error('Failed to load delivery')
    } finally {
      setLoading(false)
    }
  }

  /* ================= SEARCH ================= */
  const handleSearch = (value) => {
    setSearchText(value)
    setFilteredDelivery(
      delivery.filter((d) =>
        `${d.customer_name} ${d.date}`
          .toLowerCase()
          .includes(value.toLowerCase()),
      ),
    )
  }

  /* ================= BARCODE ================= */
  const fetchProductByBarcode = async (barcode) => {
    if (!barcode || !customerId || isFetchingRef.current) return
    isFetchingRef.current = true

    try {
      const res = await axiosInstance.post(GetProductDataByBarcodeAPI, {
        prod_id: barcode,
        cust_id: customerId,
      })

      if (!Array.isArray(res.data) || res.data.length === 0) {
        toast.error('Product not found')
        return
      }

      const p = res.data[0]

      const baseStock = Number(p.available_stock || 0)
      const originalQty = isEdit ? originalQtyMap[p.prod_id] || 0 : 0
      const effectiveStock = baseStock + originalQty

      setItems((prev) => {
        const exists = prev.find((i) => i.product_id === p.prod_id)

        if (exists) {
          if (exists.qty + 1 > effectiveStock) {
            toast.error('No stock available', {
              toastId: `stock-${p.prod_id}`,
            })
            return prev
          }

          return prev.map((i) =>
            i.product_id === p.prod_id ? { ...i, qty: i.qty + 1 } : i,
          )
        }

        if (effectiveStock < 1) {
          toast.error('Out of stock')
          return prev
        }

        return [
          ...prev,
          {
            product_id: p.prod_id,
            product_name: p.product_name,
            size: p.size,
            qty: 1,
            rate: p.approval_rate ?? p.rate,
            available_stock: effectiveStock,
          },
        ]
      })

      setProductId('')
      scanRef.current?.focus()
    } catch {
      toast.error('Invalid barcode')
    } finally {
      isFetchingRef.current = false
    }
  }

  // useEffect(() => {
  //   const delay = setTimeout(() => {
  //     if (productId) fetchProductByBarcode(productId)
  //   }, 400)

  //   return () => clearTimeout(delay)
  // }, [productId])

  /* ================= REMOVE ================= */
  const removeItem = (index) => {
    setItems((prev) =>
      prev.flatMap((item, i) => {
        if (i !== index) return item
        if (item.qty > 1) return { ...item, qty: item.qty - 1 }
        return []
      }),
    )
  }

  /* ================= TOTALS ================= */
  const grossTotalQty = items.reduce((s, i) => s + Number(i.qty || 0), 0)
  const grossTotalAmt = items.reduce(
    (s, i) => s + Number(i.qty || 0) * Number(i.rate || 0),
    0,
  )

  /* ================= SUBMIT ================= */
  const handleSubmit = async () => {
    if (!deliveryDate || !customerId || !items.length)
      return toast.error('Incomplete data')

    const payload = {
      date: deliveryDate.format('YYYY-MM-DD'),
      cust_id: customerId,
      status: 1,
      year: selectedYear,
      items: items.map((i) => ({
        prod_id: i.product_id,
        quantity: i.qty,
        rate: i.rate,
      })),
    }

    try {
      setSubmitLoading(true)
      const res = isEdit
        ? await axiosInstance.put(`${UpdateDeliveryDataAPI}/${editId}`, payload)
        : await axiosInstance.post(CreateDeliveryDataAPI, payload)

      toast.success(res.data === 'UPDATED' ? 'Updated!' : 'Saved!')
      setIsModalOpen(false)
      resetForm()
      fetchDelivery()
    } catch {
      toast.error('Save failed')
    } finally {
      setSubmitLoading(false)
    }
  }

  const resetForm = () => {
    setDeliveryDate(null)
    setCustomerId(null)
    setProductId('')
    setQty(1)
    setItems([])
    setOriginalQtyMap({})
    setIsEdit(false)
    setEditId(null)
  }

  /* ================= EDIT ================= */
  const handleEdit = (record) => {
    setIsEdit(true)
    setEditId(record.delivery_id)
    setDeliveryDate(dayjs(record.date))
    setCustomerId(record.cust_id)

    const qtyMap = {}

    setItems(
      record.items.map((i) => {
        qtyMap[i.prod_id] = i.quantity
        return {
          product_id: i.prod_id,
          product_name: i.product_name,
          size: i.size,
          qty: i.quantity,
          rate: i.rate,
        }
      }),
    )

    setOriginalQtyMap(qtyMap)
    setIsModalOpen(true)
  }

  return (
    <>
      <div className="mainContainer">
        <h3>
          <SlackOutlined style={{ color: 'orangered' }} /> Delivery
        </h3>

        <div className="search-bar text-end">
          <Button
            className="addButton mx-md-2"
            icon={<PlusOutlined />}
            loading={addBtnLoading}
            onClick={() => {
              setAddBtnLoading(true)

              resetForm()
              setIsEdit(false)
              setEditId(null)
              setIsModalOpen(true)

              setAddBtnLoading(false)
            }}
          >
            Add
          </Button>

          <Input
            placeholder="Search"
            value={searchText}
            onChange={(e) => handleSearch(e.target.value)}
            style={{ width: 250, marginLeft: 10 }}
          />
        </div>

        <Table
          columns={deliveryColumns}
          dataSource={filteredDelivery}
          loading={loading}
          rowKey="delivery_id"
          bordered
          className="shadow"
          style={{ overflowX: 'auto' }}
        />
      </div>

      {/* ADD MODAL */}
      <Modal
        open={isModalOpen}
        title={isEdit ? 'Edit Delivery' : 'Delivery Entry'}
        onCancel={() => setIsModalOpen(false)}
        onOk={handleSubmit}
        okText="Save"
        width={900}
        okButtonProps={{
          loading: submitLoading,
        }}
      >
        <div className="row">
          <div className="col-12 col-md-4 mb-2">
            <label>Date</label>
            <DatePicker
              value={deliveryDate}
              onChange={setDeliveryDate}
              style={{ width: '100%' }}
            />
          </div>
          <div className="col-12 col-md-8 mb-2">
            <label>Customer Name</label>
            <Select
              value={customerId}
              onChange={(value) => {
                setCustomerId(value)
                resetFields()
              }}
              placeholder="Select Customer"
              style={{ width: '100%' }}
            >
              {customers.map((c) => (
                <Select.Option key={c.id} value={c.id}>
                  {c.customer_name}
                </Select.Option>
              ))}
            </Select>
          </div>
          <div className="col-12 col-md-4 mb-2">
            <label>Scan Here</label>
            <Input
              ref={scanRef}
              placeholder="Scan or Enter Product ID"
              value={productId}
              onChange={(e) => setProductId(e.target.value)}
              onBlur={() => {
                if (productId) {
                  fetchProductByBarcode(productId)
                }
              }}
              onPressEnter={() => {
                if (productId.trim()) {
                  fetchProductByBarcode(productId.trim())
                }
              }}
            />
          </div>
          <div className="col-12 col-md-2 mb-2">
            <label>Qty</label>
            <Input placeholder="Qty" value={qty} disabled />
          </div>
        </div>

        <Table
          columns={tempColumns}
          dataSource={items}
          pagination={false}
          rowKey={(_, i) => i}
          bordered
          className="shadow"
          style={{ marginTop: 15, overflowX: 'auto' }}
        />

        {/* TOTALS */}
        <div
          style={{
            padding: 12,
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 40,
            fontWeight: 600,
          }}
        >
          <div className="px-2 py-1">Gross Qty: {grossTotalQty}</div>
          <div className="px-2 py-1">
            Gross Amount: ₹ {grossTotalAmt.toFixed(2)}
          </div>
        </div>
      </Modal>

      {/* VIEW MODAL */}
      <Modal
        open={viewModal}
        title="Delivery Details"
        bordered
        footer={null}
        onCancel={() => setViewModal(false)}
      >
        {selectedDelivery && (
          <div className="row" style={{ marginBottom: 12 }}>
            <div className="col-12 col-md-8">
              <strong>Customer:</strong> {selectedDelivery.customer_name}
            </div>
            <div className="col-12 col-md-4 text-md-end">
              <strong>Date:</strong>{' '}
              {dayjs(selectedDelivery.date).format('DD-MM-YYYY')}
            </div>
          </div>
        )}

        <Table
          columns={[
            { title: 'Product ID', dataIndex: 'prod_id' },
            {
              title: 'Product',
              render: (_, record) => `${record.product_name} ${record.size}`,
            },
            { title: 'Qty', dataIndex: 'qty' },
            { title: 'Rate (₹)', dataIndex: 'rate' },
            {
              title: 'Amount (₹)',
              dataIndex: 'amount',
              align: 'right',
              render: (v) => ` ${v}`,
            },
          ]}
          dataSource={selectedDelivery?.items || []}
          pagination={false}
          style={{ overflowX: 'auto' }}
          bordered
          className="shadow"
        />

        <div className="row mt-2" style={{ fontWeight: 600 }}>
          <div className="col-12 col-md-6">
            Total Qty: {selectedDelivery?.totalQty || 0}
          </div>
          <div className="col-12 col-md-6 text-md-end">
            Net Amount: ₹ {selectedDelivery?.totalAmt || '0.00'}
          </div>
        </div>
      </Modal>
    </>
  )
}

export default Delivery
